// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Science_contentWrapper__awswY"};